import React, { createContext, useState } from "react";

export const BodyContext = createContext<Partial<BodyContextType>>({});

const BodyProvider = ({ children }) => {
  const [scrollx, setScrollx] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [modalCard, setModalCard] = useState<CardsConecta>({} as CardsConecta);
  const [search, setSearch] = useState<string>("");
  const [user, setUser] = useState<User>({} as User);
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [cardFavs, setCardFavs] = useState<Favorite[]>([]);
  const [biCardFavs, setBiCardFavs] = useState<Favorite[]>([]);
  const [allCards, setAllCards] = useState<CardsConecta[]>([])
  const [allCardsBI, setAllCardsBI] = useState<CardsConectaBI[]>([]);
  const [loadingFavCards, setLoadingFavCards] = useState<boolean>(false);
  const [loadingFavBICards, setLoadingFavBICards] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  //Menu
  const [btnCategory, setBtnCategory] = useState<boolean>(true);
  const [btnAll, setBtnAll] = useState<boolean>(false);
  const [btnFavorite, setBtnFavorite] = useState<boolean>(false);
  const [btnBiFavorite, setBtnBiFavorite] = useState<boolean>(false);
  const [btnNews, setBtnNews] = useState<boolean>(false);
  const [btnBI, setBtnBI] = useState<boolean>(false);
  const [openMenuMobile, setOpenMenuMobile] = useState<boolean>(false);
  //MENU ADMIN
  const [btnAdminCards, setBtnAdminCards] = useState<boolean>(true)
  const [btnAdminUsers, setBtnAdminUsers] = useState<boolean>(false)
  const [btnAdminCategories, setBtnAdminCategories] = useState<boolean>(false)
  const [categoryBI, setCategoryBI] = useState<CategoryBI | undefined>()
  const [loadingAdminBI, setLoadingAdminBI] = useState<boolean>(false)

  //FOR MASTER USER
  const [showCardAdmin, setShowCardAdmin] = useState<boolean>(true)
  const [showCardBIAdmin, setShowCardBIAdmin] = useState<boolean>(false)

  //Teste
  const [urlString, setUrlString] = useState<string>("")

  // FIXEME
  const logOut = (instance) => {
    localStorage.clear();
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  };

  const values: BodyContextType = {
    scrollValue: { scrollx, setScrollx },
    openValue: { open, setOpen },
    modalCardValue: { modalCard, setModalCard },
    searchValues: { search, setSearch },
    categoryValues: { btnCategory, setBtnCategory },
    allValues: { btnAll, setBtnAll },
    allCardsValues: {allCards, setAllCards},
    allCardsValuesBI: {allCardsBI, setAllCardsBI},
    favoriteValues: { btnFavorite, setBtnFavorite, cardFavs, setCardFavs },
    biFavoriteValues: {btnBiFavorite, setBtnBiFavorite, biCardFavs, setBiCardFavs},
    newsValues: { btnNews, setBtnNews },
    biValues: {btnBI, setBtnBI},
    userValues: { user, setUser },
    cardsAdminValue: {btnAdminCards, setBtnAdminCards},
    usersAdminValue: {btnAdminUsers, setBtnAdminUsers},
    categoriesAdminValue: {btnAdminCategories, setBtnAdminCategories},
    loggedValues: { isLogged, setIsLogged },
    loadingFavValues: { loadingFavCards, setLoadingFavCards },
    loadingFavBIValues: { loadingFavBICards, setLoadingFavBICards },
    toastValue: {showToast, setShowToast},
    menuMobileValues: { openMenuMobile, setOpenMenuMobile },
    logoutValue: { logOut },
    categoryBIValue: {categoryBI, setCategoryBI},
    loadingAdminBIValue: {loadingAdminBI, setLoadingAdminBI},
    //For master user
    adminButtonValues: {showCardAdmin, setShowCardAdmin},
    adminButtonBIValues: {showCardBIAdmin, setShowCardBIAdmin},
    //Teste
    urlValue: { urlString, setUrlString }
  };

  return <BodyContext.Provider value={values}>{children}</BodyContext.Provider>;
};

export default BodyProvider;
